
import Vue from 'vue'
import App from './App'
import 'babel-polyfill'

import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import fullCalendar from './components/customComponents/fullCalendar'


import router from './router'
import 'font-awesome/css/font-awesome.css'
import * as WPS from '../static/jwps.es6'
// import preview from 'vue-photo-preview'
// import 'vue-photo-preview/dist/skin.css'
import htmlToPdf from '@/utils/htmlToPdf'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VueXgplayer from 'vue-xgplayer'
import Print from 'vue-print-nb'
import "./assets/css/iconfont/iconfont.css"
import { message } from './utils/resetMessage'; // 重写 message 方法


Vue.use(Print)


import XLSX from "xlsx"
import FileSaver from 'file-saver'
Vue.use(XLSX)
Vue.use(FileSaver)

Vue.use(VueQuillEditor)
Vue.use(VueXgplayer)
Vue.component('fullCalendar', fullCalendar)

Vue.config.productionTip = false
Vue.prototype.wps = WPS;
Vue.use(ElementUI)
Vue.prototype.$message = message;
// Vue.use(preview)
Vue.use(htmlToPdf)

// 日期转换
Vue.prototype.formatDate = function (date, num = 0) {
  let M = date.getMonth() + 1
  let D = date.getDate()
  if (num == 1) {
    //当前月一号
    return `${date.getFullYear()}-${M >= 10 ? M : '0' + M}-01`;
  }
  return `${date.getFullYear()}-${M >= 10 ? M : '0' + M}-${D >= 10 ? D : '0' + D}`;
}
//检测是不是空格或者纯空格
Vue.prototype.isNullStr = function (str) {
  if (str == "") return true;
  var regu = "^[ ]+$";
  var re = new RegExp(regu);
  return re.test(str);
}

// // 插件v-fit-columns，列宽自适应。
// import Plugin from 'v-fit-columns';
// Vue.use(Plugin);


// 引入vuex-store
import store from './store/index';

import './assets/css/tags.css'
import "./assets/css/list.css";

// 阻止全局按钮 enter事件
document.body.addEventListener('keydown', function(event) {
  // 判断按下的键是否是 Enter 键，并且目标元素是按钮
  if (event.key === 'Enter' && event.target.tagName === 'BUTTON') {
    // 阻止按钮按 Enter 触发默认行为
    document.activeElement.blur();
  }
});


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js